import { render, staticRenderFns } from "./SelectedItems.vue?vue&type=template&id=1b17392c"
import script from "./SelectedItems.vue?vue&type=script&lang=js"
export * from "./SelectedItems.vue?vue&type=script&lang=js"
import style0 from "./SelectedItems.vue?vue&type=style&index=0&id=1b17392c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports